export interface EntityWithDisplayIdentifier {
  key: string;
  identifier: string;
  distinguishedname?: string;
  displayName?: string;
  displayname?: string;
}

export function getDisplayIdentifierWithFallback(
  entity: EntityWithDisplayIdentifier,
  fallback: string
): string {
  if (!entity) {
    return fallback;
  }

  const displayNamePascal = entity.displayName?.trim();
  if (displayNamePascal) {
    return displayNamePascal;
  }

  const displayNameLower = entity.displayname?.trim();
  if (displayNameLower) {
    return displayNameLower;
  }

  const distinguishedName = entity.distinguishedname?.trim();
  if (distinguishedName) {
    return distinguishedName;
  }

  const identifier = entity.identifier?.trim();
  if (identifier) {
    return identifier;
  }

  return fallback; // Uses the explicit fallback parameter
}
